// @flow

import { pk, string } from 'fc-decoders'

import category from './decoders/category'
import shape from './decoders/shape'

import {
  PROP_ASSET_ID,
  PROP_PARENT,
  PROP_LABEL,
  PROP_CATEGORY,
  PROP_SHAPE,
  PROP_SEASON,
} from 'fc-model-assets'

export default {
  [PROP_ASSET_ID]: pk,
  [PROP_PARENT]: pk,
  [PROP_LABEL]: string,
  [PROP_CATEGORY]: category,
  [PROP_SHAPE]: shape,
  [PROP_SEASON]: pk,
}
